import React from "react";
import { SHOP } from "@/constants/testIds";

export default function CheckoutStage({
  form, setForm, baseSubtotal, gst, includeGst, deliveryFee, total, err, submitting, onPlaceOrder, onBack,
}) {
  return (
    <div data-testid={SHOP.checkoutDialog} className="flex-1 overflow-y-auto px-5 py-5 space-y-4">
      <Field
        label="Full name"
        testId={SHOP.checkoutName}
        value={form.customer_name}
        onChange={(v) => setForm({ ...form, customer_name: v })}
        placeholder="Rajesh Kumar"
      />
      <Field
        label="Phone"
        testId={SHOP.checkoutPhone}
        value={form.phone}
        onChange={(v) => setForm({ ...form, phone: v })}
        placeholder="+91 98765 43210"
      />
      <div>
        <label className="block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1.5">Address</label>
        <textarea
          data-testid={SHOP.checkoutAddress}
          value={form.address}
          onChange={(e) => setForm({ ...form, address: e.target.value })}
          placeholder="Flat, building, area"
          rows={3}
          className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:border-[#0056D2] focus:ring-2 focus:ring-[#0056D2]/20 outline-none text-sm"
        />
      </div>
      <Field
        label="Pincode"
        testId={SHOP.checkoutPincode}
        value={form.pincode}
        onChange={(v) => setForm({ ...form, pincode: v })}
        placeholder="560001"
      />

      <div className="rounded-lg bg-gray-50 border border-gray-200 p-3 text-sm">
        <div className="flex justify-between"><span className="text-gray-600">Sub Total (excl. GST)</span><span className="font-bold">₹{baseSubtotal.toLocaleString("en-IN")}</span></div>
        <div className="flex justify-between"><span className="text-gray-600">GST (18%)</span><span className={`font-bold ${includeGst ? "" : "line-through text-gray-400"}`}>{includeGst ? `₹${gst.toLocaleString("en-IN")}` : "Removed"}</span></div>
        <div className="flex justify-between"><span className="text-gray-600">Delivery</span><span className="font-bold">{deliveryFee === 0 ? <span className="text-[#16A34A]">FREE</span> : `₹${deliveryFee}`}</span></div>
        <div className="flex justify-between mt-1 pt-1 border-t border-gray-200"><span className="font-extrabold text-gray-900">Grand Total</span><span className="font-extrabold">₹{total.toLocaleString("en-IN")}</span></div>
      </div>

      {err && <div className="text-sm text-[#EF4444] font-semibold">{err}</div>}

      <button
        data-testid={SHOP.checkoutPlaceOrderBtn}
        disabled={submitting}
        onClick={onPlaceOrder}
        className="w-full h-12 rounded-lg bg-[#FF5722] hover:bg-[#E64A19] disabled:opacity-60 text-white font-extrabold uppercase tracking-wide text-sm transition-colors"
      >
        {submitting ? "Placing order..." : "Place Order (Cash on Delivery)"}
      </button>

      <button onClick={onBack} className="w-full h-10 rounded-lg border border-gray-300 hover:bg-gray-50 text-gray-700 font-bold text-sm">
        ← Back to Cart
      </button>
    </div>
  );
}

function Field({ label, testId, value, onChange, placeholder }) {
  return (
    <div>
      <label className="block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1.5">{label}</label>
      <input
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full h-11 px-3 rounded-lg border border-gray-300 focus:border-[#0056D2] focus:ring-2 focus:ring-[#0056D2]/20 outline-none text-sm"
      />
    </div>
  );
}
